import React, { useEffect, useRef, useState } from 'react';
import { ArrowUpRight, Menu, Moon, Sun, X } from 'lucide-react';
import logoDay from '../Icons/syntheticvis_logo-day.png';
import logoNight from '../Icons/syntheticvis_logo-night.png';

export const Brand = () => <>
  <img className="logo-dark" src={logoNight} alt="SyntheticVis" width="1500" height="361" />
  <img className="logo-light" src={logoDay} alt="SyntheticVis" width="1478" height="361" />
</>;

const Navbar = ({ theme, onToggleTheme }: { theme: 'dark' | 'light'; onToggleTheme: () => void }) => {
  const [open, setOpen] = useState(false);
  const toggle = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const close = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && open) { setOpen(false); toggle.current?.focus(); }
    };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, [open]);
  return (
    <header className="site-header">
      <div className="container header-inner">
        <a className="brand" href="#main" aria-label="SyntheticVis home" onClick={() => setOpen(false)}><Brand /></a>
        <span className="header-label">Research & technology</span>
        <nav id="main-navigation" aria-label="Main navigation" className={open ? 'navigation is-open' : 'navigation'}>
          <a href="#company" onClick={() => setOpen(false)}>Company</a>
          <a href="#fonfin" onClick={() => setOpen(false)}>FonFin</a>
          <a href="#approach" onClick={() => setOpen(false)}>Approach</a>
          <a href="#contact" className="nav-contact" onClick={() => setOpen(false)}>Let’s talk <ArrowUpRight size={15} /></a>
        </nav>
        <button className="icon-button theme-toggle" onClick={onToggleTheme} aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}>
          {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
        </button>
        <button ref={toggle} className="icon-button menu-toggle" aria-expanded={open} aria-controls="main-navigation" aria-label={open ? 'Close navigation' : 'Open navigation'} onClick={() => setOpen(!open)}>
          {open ? <X size={21} /> : <Menu size={21} />}
        </button>
      </div>
    </header>
  );
};
export default Navbar;
